import { Theme } from '@mui/material';

import { colors } from '@/theme/variables';

export const toolbarStyles = (theme: Theme) => ({
  GridToolbarQuickFilter: {
    background: 'transparent',
    width: '440px',
    '.MuiInputBase-root': {
      background: `${theme.palette.background.paper} !important`,
    },
  },
  GridFilterPanel: {
    '&. MuiDataGrid-panel': {
      position: 'absolute',
      right: 0,
      top: 40,
      background: theme.palette.background.paper,
      zIndex: 1,
      '& .MuiInputBase-root': {
        width: '50px',
      },
    },
  },
});

export const dataGridStyles = (theme: Theme) => ({
  borderRadius: '8px',
  borderColor: 'transparent',
  '& .MuiDataGrid-main': {
    background: theme.palette.background.paper,
    padding: '0 10px',
  },
  '& .MuiDataGrid-filler': {
    background: theme.palette.background.paper,
    borderBottom: '0px solid transparent !important',
  },
  '& .MuiDataGrid-cell': {
    borderTopColor: colors.grey[10],
  },
  '& .MuiDataGrid-cell:focus': { outline: 'none' },
  '& .MuiDataGrid-cell:focus-within': {
    outline: 'none',
  },
  '& .MuiDataGrid-cell:hover': {
    backgroundColor: 'transparent',
    cursor: 'pointer',
  },
  '& .MuiStack-root': { background: theme.palette.background.paper },
  '& .MuiDataGrid-columnHeader': {
    backgroundColor: theme.palette.background.paper,
    borderTop: `1px solid  ${colors.grey[10]}`,
    borderBottom: '2px solid transparent !important',
    zIndex: 1,
    '& .MuiInputLabel-standard': {
      position: 'relative',
      transform: 'none',
      fontSize: '0.75rem',
      paddingTop: 0,
      lineHeight: '1',
      '&.MuiInputLabel-shrink': {
        transform: 'none',
      },
    },
    '& .MuiInput-root': {
      marginTop: 0,
      paddingTop: 0,
    },
  },
  '& .MuiDataGrid-columnHeader:focus': { outline: 'none' },
  '& .MuiDataGrid-row:hover': {
    backgroundColor: theme.palette.background.default,
  },
  '& .MuiTablePagination-root': { background: theme.palette.background.paper },
  '& .MuiInputBase-root': {
    height: 'fit-content',
  },
  '& .MuiDataGrid-toolbarQuickFilter': { padding: 0, height: '38px' },
  '& .MuiDataGrid-detailPanel': { backgroundColor: colors.white },
  '& .MuiDataGrid-scrollbarFiller': { display: 'none' },

  // Ensure action columns stay visible during horizontal scrolling
  '& .MuiDataGrid-columnHeader[data-field="action"], & .MuiDataGrid-cell[data-field="action"]':
    {
      position: 'sticky',
      right: 0,
      backgroundColor: theme.palette.background.paper,
      zIndex: 1,
      '&::after': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: '-1px',
        bottom: 0,
        width: '1px',
        backgroundColor: colors.grey[10],
      },
    },
  '& .MuiDataGrid-columnHeader[data-field="action"] .MuiDataGrid-columnSeparator':
    {
      display: 'none',
    },

  '& .MuiInputBase-root.Mui-disabled': {
    backgroundColor: '#AAAFB4 !important',
    '.MuiInputBase-input.Mui-disabled': {
      color: 'rgba(255, 255, 255, 0.7) !important',
    },
  },
  '& .MuiInput-root.Mui-disabled': {
    backgroundColor: 'dimgrey',
    '&::before, &::after': {
      borderBottom: 'none',
    },
    '.MuiInput-input.Mui-disabled': {
      WebkitTextFillColor: 'rgba(255, 255, 255, 0.7) !important',
      color: 'rgba(255, 255, 255, 0.7) !important',
    },
  },
  '& .MuiInputLabel-root.Mui-disabled': {
    color: 'rgba(255, 255, 255, 0.8) !important',
  },
});
